<script>
import EditEndpointModal from "@/components/modals/endpoints/edit.vue"
// import loraSvg from "@/assets/icons/technologies/icon_lora.svg";
import mqttSvg from "@/assets/icons/technologies/icon_mqtt.svg"
// import udpSvg from "@/assets/icons/technologies/icon_udp.svg";
import httpSvg from "@/assets/icons/technologies/icon_http.svg"

export default {
  name: "DataFlowDiagramEndpointBox",
  components: { EditEndpointModal },
  props: {
    dataFlow: {
      type: Object,
      required: true
    },
    endpoint: {
      type: Object,
      required: true
    },
    showEditActions: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    isEditOpen: false,
    isKebabOpened: false
  }),
  methods: {
    getProtocolLogo(protocol) {
      switch (protocol) {
        case "HTTP":
          return httpSvg
        case "MQTT":
          return mqttSvg
        default:
          return ""
      }
    }
  }
}
</script>

<template>
  <div>
    <div class="data-flow-diagram__green-curve" />
    <div class="d-flex justify-content-between">
      <div class="data-flow-diagram__box__option__header">
        <div class="atom-icon">
          <img :src="getProtocolLogo(endpoint.protocol ?? endpoint.custDestType?.toUpperCase())" alt="" />
        </div>
        <h6 class="mb-0">
          {{ endpoint.custDestName }}
        </h6>
      </div>

      <!-- TODO(?) consider use of EditDeleteKebab.vue -->
      <div class="dropdown-actions">
        <div class="atom-icon d-block mr-0 cursor-pointer" @click="isKebabOpened = true">
          <img height="32" src="@/assets/icons/menu/ico-kebab.svg" />
        </div>
        <div
          v-if="isKebabOpened"
          v-click-outside="
            () => {
              isKebabOpened = false
            }
          "
          class="dropdown-actions__wrapper"
          style="width: max-content"
        >
          <div class="dropdown-actions__inner">
            <RouterLink
              :to="{
                name: endpoint.protocol === 'MQTT' ? 'mqttEndpoint' : 'endpoint',
                params: {
                  customerId: $route.params.customerId,
                  projectId: endpoint.projectId,
                  id: endpoint.custDestId
                }
              }"
              class="text-decoration-none"
            >
              <div class="dropdown-actions__item d-flex align-items-center text-black">
                <div class="atom-icon">
                  <img alt="" src="@/assets/icons/actions/icon_preview_border.svg" />
                </div>
                <span style="color: #212529">{{ $t("SHOW_DETAIL") }}</span>
              </div>
            </RouterLink>
            <div v-if="showEditActions" class="dropdown-actions__item d-flex align-items-center" @click="isEditOpen = true">
              <div class="atom-icon">
                <img alt="" src="@/assets/icons/actions/ico-ico-upravitzarizeni.svg" />
              </div>
              {{ $t("EDIT") }}
            </div>
            <div v-if="showEditActions" class="dropdown-actions__item d-flex align-items-center" @click="$emit('remove')">
              <div class="atom-icon">
                <img alt="" src="@/assets/icons/actions/ico-ico-delete-l.svg" />
              </div>
              {{ $t("REMOVE") }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-show="endpoint.custDestDescription">
      {{ endpoint.custDestDescription }}
    </div>

    <EditEndpointModal
      :opened="isEditOpen ? ['editEndpoint'] : []"
      :original-endpoint="endpoint"
      :protocol="endpoint.protocol"
      :show-data-flows="false"
      @close-box="isEditOpen = false"
      @open-box="isEditOpen = true"
      @reload-items="endpoint.custDestName = $event.custDestName; endpoint.custDestDescription = $event.custDestDescription"
    />
  </div>
</template>
